import React, { useEffect, useRef, useState } from 'react'
import { HiSpeakerWave, HiSpeakerXMark } from "react-icons/hi2"
import BgMusic from '../Assets/music.mp3'

export default function Music({ userInteracted }) {
    const audioRef = useRef()
    const [isPlaying, setIsPlaying] = useState(true)

    useEffect(() => {
        if (userInteracted && audioRef.current) {
            isPlaying ? audioRef.current.play() : audioRef.current.pause()
        }
    }, [userInteracted, isPlaying])

    function togglePlayback() {
        setIsPlaying(!isPlaying)
    }

    return (
        <>
            <audio ref={audioRef} loop>
                <source src={BgMusic} type="audio/mp3" />
                Your browser does not support the audio element.
            </audio>
            <button onClick={togglePlayback}>
                {userInteracted && isPlaying ? <HiSpeakerWave /> : <HiSpeakerXMark />}
            </button>
        </>
    )
}